import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { MatSelectInfiniteScrollModule } from 'ng-mat-select-infinite-scroll';
import { BranchListSelectComponent } from './branch-list-select/branch-list-select.component';
import { LeaderListSelectComponent } from './leader-list-select/leader-list-select.component';
import { IntroducerListSelectComponent } from './introducer-list-select/introducer-list-select.component';
import { MatSelectCompatDirective, MatOptionCompatDirective } from 'src/app/directives/mat-select-compat.directive';
@NgModule({
  declarations: [BranchListSelectComponent, LeaderListSelectComponent, IntroducerListSelectComponent, MatSelectCompatDirective, MatOptionCompatDirective],
  exports: [BranchListSelectComponent, LeaderListSelectComponent, IntroducerListSelectComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatSelectModule,
    NgxMatSelectSearchModule,
    MatSelectInfiniteScrollModule,
    MatProgressSpinnerModule
  ],
})
export class SelectSearchModule { }
